export const JURISDICTION_PALINS_NORTH = 'Plains - North'
export const JURISDICTION_PALINS_SOUTH = 'Plains - South'